import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const HeaderContent = styled.div`
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;

  padding: 15px;

  height: 100%;

  @media (min-width: ${getBreakpoint('xxl')}) {
    flex-direction: row;

    padding: 0 375px;
  }

  svg {
    path,
    polygon,
    rect {
      fill: ${getColor('white')};
    }
  }

  a {
    &:hover {
      svg {
        path,
        polygon,
        rect {
          fill: ${getColor('accentGreen')};
        }
      }
    }

    svg {
      &.logo {
        width: 150px;

        @media (min-width: ${getBreakpoint('lg')}) {
          width: auto;
        }
      }
    }
  }
`;

export default HeaderContent;
